import React, { FC } from 'react';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import InputText, { InputType } from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import { setAccountId } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const InputAccountId: FC = () => {
    const accountId = useSelector((state) => state.acts.accountId);
    const dispatch = useDispatch();
    const trl = useTrls();

    return (
        <FormSpacer>
            <InputText
                type={InputType.Number}
                value={accountId || ''}
                onChange={(value: number) => dispatch(setAccountId(value))}
                size="10"
                placeholder={trl('admin.actsReport.Filter.accountId')}
            />
        </FormSpacer>
    );
};

export default InputAccountId;
